export default {
  methods: {
    isAuthorized(authLevel) {
      this.authLevel = this.$auth.user() ? this.$auth.user().role : 'ANONYMOUS'
      switch (authLevel) {
        case undefined:
        case 'ANONYMOUS':
          return true
        case 'USER':
          return this.authLevel === 'USER' || this.authLevel === 'CONTENT_CREATOR' || this.authLevel === 'ADMIN' || this.authLevel === 'SUPER_ADMIN'
        case 'CONTENT_CREATOR':
          return this.authLevel === 'CONTENT_CREATOR' || this.authLevel === 'ADMIN' || this.authLevel === 'SUPER_ADMIN'
        case 'ADMIN':
          return this.authLevel === 'ADMIN' || this.authLevel === 'SUPER_ADMIN'
        case 'SUPER_ADMIN':
          return this.authLevel === 'SUPER_ADMIN'
        default:
          return false
      }
    }
  }
}